import { render, staticRenderFns } from "./CommunicationsTableFilters.vue?vue&type=template&id=4f57abcf"
import script from "./CommunicationsTableFilters.vue?vue&type=script&lang=ts"
export * from "./CommunicationsTableFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports